import * as React from "react";
import { useTheme } from "@mui/material/styles";
import Box from "@mui/material/Box";
import OutlinedInput from "@mui/material/OutlinedInput";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import Chip from "@mui/material/Chip";
import PropTypes from "prop-types";
import { useFormContext } from "react-hook-form";
import { FormHelperText } from "@mui/material";

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
	PaperProps: {
		style: {
			maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
			width: 250,
		},
	},
};

const names = [
	"Oliver Hansen",
	"Van Henry",
	"April Tucker",
	"Ralph Hubbard",
	"Omar Alexander",
	"Carlos Abbott",
	"Miriam Wagner",
	"Bradley Wilkerson",
	"Virginia Andrews",
	"Kelly Snyder",
];

function getStyles(name, personName, theme) {
	return {
		fontWeight:
			personName.indexOf(name) === -1
				? theme.typography.fontWeightRegular
				: theme.typography.fontWeightMedium,
	};
}

export default function SelectFormItem(props) {
	const {
		name,
		required,
		disabled,
		onChange,
		label,
		labelString,
		multiple,
		small,
		options,
		IsRadius,
	} = props;

	const {
		register,
		setValue,
		watch,
		formState: { errors },
	} = useFormContext();

	const theme = useTheme();
	const [personName, setPersonName] = React.useState([]);

	const handleChange = (event) => {
		
		const {
			target: { value },
		} = event;
		// setValue(target)
		let lstOpt = (options || []).find(m => m.value == event.target.value);

		setValue(name, lstOpt);
		setPersonName(
			// On autofill we get a stringified value.
			typeof value === "string" ? value.split(",") : value
		);
	};

	return (
		<div>
			<FormControl fullWidth>
				<InputLabel
					htmlFor="input"
					sx={{
						top: "0",
						" > label": {
							"::after": {
								content: required ? '" * "' : '""',
								color: "red",
								fontWeight: 500,
							},
						},
						color: errors && errors[name] ? "red!important" : "",
					}}
				>
					{label}
				</InputLabel>
				<Select
					name={name}
					inputRef={register(name).ref}
					{...register(name)}
					fullWidth
					multiple={multiple}
					value={watch(name) || ""}
					// onChange={handleChange}
					disabled={disabled}
					size={small ? "small" : "medium"}
					onChange={(e, v) => {
						handleChange(e)
						onChange && onChange(v)
					}}
					input={
						<OutlinedInput 
							id="select-multiple-chip" 
							label="Chip" 
							sx={{
								borderRadius: IsRadius ? "50px" : "4px",
								// "& .MuiOutlinedInput-root": {
								//   borderRadius: IsRadius ? "50px" : "4px",
								 
								// },
							}}
						/>
					}
					renderValue={(selected) => (
						<Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
								{selected.icon}{selected.label}
						</Box>
					)}
				>
					{options.map((Item, inx) => (
						<MenuItem
							key={inx}
							value={Item.value}
						>
							{Item.icon}
							{Item.label}
						</MenuItem>
					))}
				</Select>
			</FormControl>
		</div>
	);
}

SelectFormItem.propTypes = {
	name: PropTypes.string.isRequired,
	required: PropTypes.bool,
	disabled: PropTypes.bool,
	onChange: PropTypes.func,
	label: PropTypes.any,
	labelString: PropTypes.any,
	multiple: PropTypes.bool,
	small: PropTypes.bool,
	options: PropTypes.any,
	IsRadius: PropTypes.bool,
};

SelectFormItem.defaultProps = {
	options: [],
	multiple: false,
	IsRadius: false,
	small : true
};